import React, { useState, useEffect } from 'react';
import config from '../config';


function Footer() {
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentYear(new Date().getFullYear());
        }, 1000 * 60); // Update every minute to handle cases where the year changes while the user is on the page

        return () => clearInterval(intervalId); // Cleanup function
    }, []);

    return (
        <div>
            <footer className="site-footer">
                <div className="site-footer__shape-1 float-bob-y">
                    <img src="assets/images/shapes/site-footer-shape-1.png" alt="" />
                </div>
                <div className="site-footer__top">
                    <div className="container">
                        <div className="site-footer__top-inner" style={{ gap: '40px', flexWrap: 'wrap' }}>
                            <div className="site-footer__top-left">
                                <div className="site-footer__top-icon">
                                    <span className="icon-business-people"></span>
                                </div>
                                <div className="site-footer__top-content">
                                    <h3>
                                        Operating Hours:
                                        <span style={{ fontSize: '13px', fontWeight: 'normal', display: 'block', marginTop: '8px', lineHeight: '22px' }}>
                                            <strong>RHCA - Hosur:</strong> Mon – Fri: 9:00 AM – 4:30 PM | Saturday (1st, 3rd, 5th): 9:00 AM – 2:45 PM | Sunday: Closed
                                            <br />
                                            <strong>RHCA - Electronic City:</strong> Mon – Fri: 9:00 AM – 6:00 PM | Saturday (1st, 3rd, 5th) : 9:00 AM – 3:00 PM | Sunday: Closed
                                        </span>
                                    </h3>
                                </div>
                            </div>
                            <div className="site-footer__top-right">
                                <div className="site-footer__social-shape-1 float-bob-y">
                                    <img src="assets/images/shapes/site-footer-social-shape.png" alt="" className="zoom-fade" />
                                </div>
                                <div className="site-footer__social-title">
                                    <p>Follow on:</p>
                                </div>
                                <div className="site-footer__social">
                                    <a href="https://youtube.com/@rhca-india?si=Pu2jro4V4E-xB_l_" target='_blank' rel="noopener noreferrer"><i className="fab fa-youtube"></i></a>
                                    <a href="https://www.facebook.com/rayofhopeACA?mibextid=rS40aB7S9Ucbxw6v" target='_blank' rel="noopener noreferrer"><i className="fab fa-facebook"></i></a>
                                    <a href="https://www.linkedin.com/company/ray-of-hope-center-for-autism/" target='_blank' rel="noopener noreferrer"><i className="fab fa-linkedin"></i></a>
                                    <a href="https://www.instagram.com/rhcahosur?igsh=dmV5ZHA2czhsNWlv" target='_blank' rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="site-footer__middle">
                        <div className="row">
                            <div className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="100ms">
                                <div className="footer-widget__column footer-widget__about">
                                    <div className="footer-widget__logo">
                                        <a href="/"><img src={`${config.baseUrl}/assets/images/rohlogo.png`} alt="" width="50%" /></a>
                                    </div>
                                    <p className="footer-widget__about-text">Ray of Hope Centre for Autism</p>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="200ms">
                                <div className="footer-widget__column footer-widget__link">
                                    <div className="footer-widget__title-box">
                                        <h3 className="footer-widget__title">Explore</h3>
                                    </div>
                                    <ul className="footer-widget__link-list list-unstyled">
                                        <li><a href="/">Home</a></li>
                                        <li><a href="/about-us">About Us</a></li>
                                        <li><a href="/applied-behavioral-analysis">Departments</a></li>
                                        <li><a href="/early-intervention-program">Programs</a></li>
                                        <li><a href="/our-team">Our Team</a></li>
                                        {/* <li><a href="faq.html">Beyond Therapy</a></li> */}
                                        <li><a href="/faq">FAQs</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-xl-5 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="300ms">
                                <div className="footer-widget__column footer-widget__Contact">
                                    <div className="footer-widget__title-box">
                                        <h3 className="footer-widget__title">Contact</h3>
                                    </div>
                                    <ul className="footer-widget__Contact-list list-unstyled">
                                        <li>
                                            <div className="icon">
                                                <span className="fas fa-map-marker"></span>
                                            </div>
                                            <div className="text">
                                                <span>Visit Office - Hosur</span>
                                                <p>Asian Christian Academy, Jeemangalam, Bagalur (P.O), Hosur, Krishnagiri (Dist.), Tamil Nadu - 635103, India.</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="icon">
                                                <span className="fas fa-map-marker"></span>
                                            </div>
                                            <div className="text">
                                                <span>Visit Office - Electronic City</span>
                                                <p>RR Towers, 134/106/43, Hosur Main Road, Hosa Road Intersection, Opposite Hosa Road Metro station, Chikkathoguru, Bengaluru, Karnataka – 560100</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="icon">
                                                <span className="fas fa-envelope"></span>
                                            </div>
                                            <div className="text">
                                                <span>Send Email</span>
                                                <p><a href="mailto:rayofhope@acaindia.org">rayofhope@acaindia.org</a></p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="icon">
                                                <span className="fas fa-phone-square"></span>
                                            </div>
                                            <div className="text">
                                                <span>Call Anytime</span>
                                                <p style={{ fontSize: '13px', lineHeight: '22px' }}>
                                                    <strong>Hosur:</strong> <a href="tel:04344255800,878" style={{ color: 'inherit', textDecoration: 'none' }}>04344 - 255800 (Ext. 878)</a>
                                                    <br />
                                                    <strong>Electronic City:</strong> <a href="tel:7305989924" style={{ color: 'inherit', textDecoration: 'none' }}>7305989924</a>
                                                </p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="site-footer__bottom">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="site-footer__bottom-inner">
                                    <p className="site-footer__bottom-text">© Copyright <span className="dynamic-year">{currentYear}</span> Ray of Hope Centre for Autism.All Rights Reserved. <a href='/terms-and-conditions'> Privacy Policy | Terms & Conditions</a>. Powered By <a href='https://media-aca.org/' target='_blank' rel="noopener noreferrer"> ACA Media</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    )
}

export default Footer